import{ Api } from "../Api";
require('dotenv');
const axios = require('axios').default;


let MigrateStudentsApi =
{
    endpoint : "MigrateStudents/",

    async upload(csvFile) {
        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint

        const formData = new FormData();
        formData.append('file', csvFile);

        const response = await axios.post(URL, formData, {
                withCredentials : true,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

        return response.data;
    }
}

//Assign Api Mixin 
MigrateStudentsApi = Object.assign({}, Api, MigrateStudentsApi);

export { MigrateStudentsApi }
